export class CustomerPortal {
    private readonly loginNav = $(".nav-377");
    private readonly loginLink = this.loginNav.find('a');
    private readonly navMobile = $("#nav-mobile");
    private readonly currentPage = (window as any).$2sxc.env.page();
    private readonly isExtranetPage = [200, 7197].includes(this.currentPage);
    private readonly routePrefix = '/extranet'; // old: '/extranet#/'

    private get user() {
        if (!((window as any).Cookies('ExtranetAccessToken'))) {
            return null;
        }
        return localStorage.getItem('ls.ExtranetUser');
    }

    constructor() {
        if (this.user || this.isExtranetPage) {
            this.loginNav.addClass('dropdown');
            this.loginLink
                .attr('data-toggle', 'dropdown')
                .dropdown()
                .on('click', event => {
                    if (this.user)
                        event.preventDefault();
                });
        }

        if (this.isExtranetPage) {
            window.addEventListener("message", (event) => {
                try {
                    const data = JSON.parse(event.data);
                    if (data.type === "auth") {
                        this.updateUserLinks(data.user, data.authentication);
                    }
                } catch (e) {
                    // console.log(":", event.data);
                }
            });
        }
        else if (this.user) {
            this.updateUserLinks(JSON.parse(this.user));
        }
    }

    updateUserLinks = (user: IUser | null, authentication: IAuthentication | null = null) => {
        this.loginNav.toggleClass('is-authenticated', !!user);
        this.navMobile.find(".nav-mobile-customer-portal").toggleClass('is-authenticated', !!user);

        // update loginLink-text
        this.loginLink.text(user ? user.Initials : '');
        this.navMobile.find('.name').text(user ? user.FirstName : '');
        this.navMobile.find('.profile-circle').text(user ? user.Initials : '');

        // append/remove User-Menu (Mobile and Desktop)
        $('.cp-user-menu').remove();
        if (user) {
            this.loginNav.append(this.getUserMenuDesktop(user));
            // 2ro - removed after feedback from pascal
            // this.navMobile.append(this.getUserMenuMobile(user));
        }

        // append/remove exit-impersonation
        $(".exit-impersonation").remove();
        if (authentication?.isAuth && authentication?.impersonation_originalUserName.length > 0) {
            const exitImpersonation = $(`<li class="exit-impersonation">
                <a title="Switch back to ${authentication.impersonation_originalUserName}"><i class="fa fa-sign-out" aria-hidden="true"></i></a>
            </li>`);
            exitImpersonation.find('a').on('click', () => {
                const message = {
                    type: "exit-impersonation",
                };
                window.parent.postMessage(JSON.stringify(message), "*");
            });
            this.loginNav.after(exitImpersonation);
        }
    }

    getUserMenuMobile = (user: IUser) => {
        let items = `<li><a href="${this.routePrefix}/myProfile">My Profile</a></li>
                    <li><a href="${this.routePrefix}/companyProfile">My Company Profile</a></li>`;

        if (user.ShowUserManagement)
            items += `<li><a href="${this.routePrefix}manageUsers">Users Management</a></li>`;
        if (user.AllowImpersonation)
            items += `<li><a href="${this.routePrefix}/impersonation">Impersonation</a></li>`;

        return `<ul class="ly-nav ly-nav-sub cp-user-menu">${items}</ul>`;
    }

    getUserMenuDesktop = (user: IUser) =>
        `<ul class="dropdown-menu cp-user-menu">
            <li><a href="${this.routePrefix}/home">My Account</a></li>
            <li><a href="/help">Documentation</a></li>
            <li><a href="${this.routePrefix}/downloads">Downloads</a></li>
            <li><a href="${this.routePrefix}/logout">Sign Out</a></li>
        </ul>`;
}

interface IAuthentication {
    isAuth: boolean;
    impersonation_originalUserName: string;
    user: IUser
}

interface IUser {
    Initials: string;
    FirstName: string;
    LastName: string;
    ShowUserManagement: boolean;
    AllowImpersonation: boolean;
}